import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import LoadingButton from 'atoms/LoadingButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
  open: boolean;
  dialogTitle: string;
  children: React.ReactNode;
  disableCancel?: boolean;
  disableSave?: boolean;
  saveButtonText?: string;
  loading?: boolean;
  onClose: () => void;
  onSave: () => void;
}

function DeleteConfirmationDialog({
  open,
  dialogTitle,
  children,
  disableCancel,
  disableSave,
  saveButtonText = 'save',
  loading,
  onClose,
  onSave,
}: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="delete-confirmation">
      <DialogTitle id="delete-confirmation">{dialogTitle}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={disableCancel}>
          Cancel
        </Button>
        <LoadingButton
          onClick={onSave}
          disabled={disableSave}
          variant="contained"
          className={classes.saveButton}
          label={saveButtonText}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  saveButton: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));

export default DeleteConfirmationDialog;
